import { ModalMessage } from "core/components/modalMessage/modalMessage";
import { Localizer } from "infrastructure/localization/localizer";
import {ReactComponent as IosShareIcon } from "../../../../content/icons/ios_share.svg";
import { CSSProperties } from "react";


type InstallPwaInstructionsModalProps = {
  modalId: string;
}

export const InstallPwaInstructionsModal = ({
  modalId
}: InstallPwaInstructionsModalProps) => {

  const textSpacingCssProps: CSSProperties = {
    marginRight: '3px'
};

  return (
    <ModalMessage 
        modalId={modalId}
        headerTitle={Localizer.pwa_InstallApp()}
        description={Localizer.pwa_IosInstallInstructions_ToInstallTheApp()}
        primaryButtonText={Localizer.global_luk()}
        bodyContent={
          <p>
            <li>
              <span style={textSpacingCssProps}>{Localizer.pwa_IosInstallInstructions_ClickOnIconText()}</span> 
              <IosShareIcon
                style={{ verticalAlign: "text-bottom" }}
                width={22} 
                height={22}
              />
            </li>
            <li>
              <span style={textSpacingCssProps}>{Localizer.pwa_IosInstallInstructions_ChooseOption()}</span>
              <span>{`"${Localizer.pwa_IosInstallInstructions_IosAddToHomeScreenOptionText()}"`}</span>
            </li>
          </p>
        }
      />
  );
}